// Motif pour lequel une ligne APCP n'a pas ete importee ou reprise : le premier
// controle en echec, dans l'ordre des controles du back
enum MotifNonImport {
	IMPUTATION_NON_TROUVEE = 'imputation_non_trouvee',
	IMPUTATION_CADUQUE = 'imputation_caduque',
	// Controles en saisie decentralisee par service seulement
	SERVICE_SANS_ESPACE = 'service_sans_espace',
	IMPUTATION_HORS_ESPACE = 'imputation_hors_espace',
}

export default MotifNonImport;
